import AreaLayer from "./AreaLayer";
import * as types from "../../store/modules/area/areatype";
import * as canvastypes from "../../store/modules/canvas/canvastypes";
import * as flowEvents from "../../events/FlowEvents";
import { containRestrict } from "./AreaUtil";

import { TweenMax, Expo } from "gsap";
import { trimImg } from "../bg/BgUtil";

import { gotoTutorial } from "../../util/StoreUtil";

import Konva from "konva";
import { Preloader } from "../../loader/Preloader";
import { animScale } from "../../util/TweenUtil";

const largeCrop = 1000;

export default class AreaManager {
  constructor(stage, width, height, store, bgLayer) {
    this.store = store;
    this.area = this.store.state.area;
    this.stage = stage;
    this.bgLayer = bgLayer;
    this.cropRect = store.state.area.crop;
    this.img = null;
    this.areaLayer = new AreaLayer(this.stage, width, height, this.cropRect);

    // this.bgLayer.on("dragstart", () => {
    //   this.onDragStartBg();
    // });
    // this.bgLayer.on("dragend", () => {
    //   this.onDragEndBg();
    // });
    flowEvents.FlowEvents.on(flowEvents.DETERMINE_AREA, () => {
      // if (this.isOutOfArea()) {
      //   alert("エリア範囲外です");
      //   return;
      // }
      this.onDetermineArea();
    });
    // flowEvents.FlowEvents.on(flowEvents.RESET_AREA, () => {
    //   this.resetArea();
    // });
  }

  onDetermineArea() {
    if (this.containRestrict_()) {
      alert("赤い斜線が少ないエリアを選択してください");
      return;
    }

    flowEvents.FlowEvents.emit(flowEvents.END_AREA);
    // this.bgLayer.draggable(false);
    // this.animateBg();
  }

  containRestrict_() {
    const img = document.getElementById("kinsiImg");
    console.log("img", img);
    return containRestrict(
      img,
      img.width * 10,
      // this.img.width(),
      this.area.pos,
      this.area.crop
    );
  }

  onDragStartBg() {
    // this.store.dispatch(types.namespace + types.SET_POS, {x: this.bgLayer.x(), y: this.bgLayer.y()})
  }
  onDragEndBg() {
    this.calcPos();
    if (this.isOutOfArea()) {
      this.moveArea();
    }
  }

  enable() {
    this.areaLayer.enable();
    this.bgLayer.draggable(false);
  }
  disable() {
    this.areaLayer.disable();
  }

  fitArea(img, bgKinsi) {
    this.img = img;
    this.bgKinsi = bgKinsi;
    this.areaLayer.fitArea(img);
    this.calcPos();
  }

  calcPos() {
    if (!this.img) return;
    const x =
      (this.img.width() - this.stage.width() - this.cropRect.width) * 0.5 -
      this.bgLayer.x();
    const y =
      (this.img.height() - this.stage.height() - this.cropRect.height) * 0.5 -
      this.bgLayer.y();
    this.dispatchPos(x, y);
  }
  dispatchPos(x, y) {
    // this.store.dispatch(types.namespace + types.SET_POS, { x, y });
  }
  resetArea() {
    this.enable();
    this.scale = 0.5;
    this.setStageScale();
    this.stage.batchDraw();
  }

  onUpdate() {
    this.setStageScale(this.scale);
  }

  onCompleteTween() {
    // gotoTutorial();
  }

  setStageScale() {
    this.store.dispatch(
      canvastypes.namespace + canvastypes.SET_SCALE,
      this.scale
    );
  }

  animateBg(duration = 1.5, ease = Expo.easeOut) {
    // const pixelRatio = this.bgLayer.width() / this.cropRect.width;
    const defaultScale = this.store.state.canvas.defaultScale;
    this.scale = this.store.state.canvas.scale;
    animScale(1, defaultScale, duration, 0, ease);
    // animateScale
    // TweenMax.to(this, 2, {
    //   scale: defaultScale,
    //   ease: Expo.easeOut,
    //   delay: 0.0,
    //   onUpdate: () => {
    //     this.onUpdate();
    //   },
    //   onComplete: () => {
    //     this.onCompleteTween();
    //   }
    // });
  }

  isOutOfArea() {
    const pos = this.area.pos;
    const crop = this.area.crop;
    if (pos.x < 0 || pos.x + crop.width > this.img.width()) return true;
    if (pos.y < 0 || pos.y + crop.height > this.img.height()) return true;

    return false;
  }

  moveArea() {
    const pos = this.area.pos;
    // const crop = this.area.crop;
    let x = this.bgLayer.x();
    let y = this.bgLayer.y();
    if (pos.x < 0) {
      x = this.fixLeftX();
    } else if (pos.x > this.img.width() - this.cropRect.width) {
      x = this.rightX();
    }
    if (pos.y < 0) {
      y = this.fixTopY();
    } else if (pos.y > this.img.height() - this.cropRect.height) {
      y = this.bottomY();
    }

    this.tween(x, y);
  }
  tween(x, y) {
    new Konva.Tween({
      node: this.bgLayer,
      x: x,
      y: y,
      duration: 0.3,
      easing: Konva.Easings.EaseInOut
    }).play();
  }

  bottomY() {
    return (
      (-this.img.height() - this.stage.height() + this.cropRect.height) * 0.5
    );
  }

  rightX() {
    return (-this.img.width() - this.stage.width() + this.cropRect.width) * 0.5;
  }

  fixTopY() {
    return (
      (this.img.height() - this.stage.height() - this.cropRect.height) * 0.5
    );
  }
  fixLeftX() {
    return (this.img.width() - this.stage.width() - this.cropRect.width) * 0.5;
  }
  createKinsi(imgId = "bgImg", layer, ratio = 1) {
    const result = this.trimImgWrap(imgId, ratio);

    const context = result.image().getContext("2d");
    const patternImg = Preloader.getImg("/img/ui/kinsi.png");
    const pattern = context.createPattern(patternImg, "repeat");
    context.fillStyle = pattern;
    context.globalCompositeOperation = "source-in";
    context.fillRect(0, 0, largeCrop, largeCrop);

    this.addToLayer(result, layer);
    return result;
  }
  createImg(imgId = "bgImg", layer, ratio = 1) {
    const result = this.trimImgWrap(imgId, ratio);
    this.addToLayer(result, layer);
    return result;
  }

  trimImgWrap(imgId, ratio) {
    const img = document.getElementById(imgId);
    const result = trimImg(
      img,
      this.store.state.area.pos,
      this.store.state.area.crop,
      { width: largeCrop, height: largeCrop },
      ratio
    );
    return result;
  }
  addToLayer(result, layer) {
    layer.add(result);
    layer.x(-largeCrop * 0.5);
    layer.y(-largeCrop * 0.5);
  }

  setKinsi(kinsiLayer) {
    this.kinsiLayer = kinsiLayer;
  }

  loadPos(pos) {
    this.img = this.createImg("bgImg", this.bgLayer, 1);
    this.bgLayer.draw();
    if (this.kinsiLayer) {
      const kinsiImg = this.createKinsi("kinsiImg", this.kinsiLayer, 10);
      this.kinsiLayer.draw(kinsiImg);
    }

    this.dispatchPos(pos.x, pos.y);
  }
  updatePosition() {
    this.loadPos(this.store.state.area.pos);
  }
}
